if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

    if(document.querySelector("product-option-set") != undefined){
       var selectoption1 = $('.swatch_button_style-0 .radio_button input[type="radio"]:checked').val();
       var selectoption2 = $('.swatch_button_style-1 .radio_button input[type="radio"]:checked').val();
       var selected_id = document.querySelector('.product-variant-id').value;
       var dynamic_code = Math.floor(100000 + Math.random() * 900000);
       var text = $('.swatch_button_style-0 .radio_button input[type="radio"]:checked').data('handle'); 
      console.log(selectoption1);
      console.log(selectoption2);
      const formData2 = {
          'items': [
            {
            'id': selected_id,
            'quantity': 1,
              properties: {
                'Main Product': text
              }
            },
            {
              'id': selectoption1,
              'quantity': 1,
              properties: {
                'Set ID': dynamic_code,
                'Main Products': text
              }
            },
            {
            'id': selectoption2,
            'quantity': 1,
            properties: {
              'Set ID': dynamic_code,
              'Main Products': text
            }
            }
          ]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData2)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
      
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
      
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            //this.cart.renderContents(response);
            setTimeout(function() {
        $.getJSON('/cart.json').then(cart => {
            fetch(routes.cart_url + '?view=item').then(response => response.text())
                .then(text => {
                    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                 
                    const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
                    const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
                    $('#CartDrawer').html(cartFormInnerHTML)
                    $('cart-drawer').removeClass('is-empty')
                    $('cart-drawer-items').removeClass('is-empty')
                    if ($('#cart-icon-bubble .cart-count-bubble').length === 0) {
                        const cartNumber = document.createElement('div')
                        cartNumber.className = 'cart-count-bubble'
                        cartNumber.innerHTML = `
                    <span aria-hidden="true">${cart.item_count}</span>
                    <span class="visually-hidden">${cart.item_count} items</span>
                    `
                        $('#cart-icon-bubble').append(cartNumber)
                    } else {
                        $('.cart-count-bubble span[aria-hidden="true"]').each((_, count) => $(count).text(cart.item_count))
                    }
                    $('#cart-icon-bubble')[0].click()
                   if(window.Rebuy){  Rebuy.init(); }
                    $('#CartDrawer-Overlay').on('click', () => {
                        $('cart-drawer').removeClass('active')
                        $('body').removeClass('overflow-hidden')
                    })
                })
        });
      
    }, 500);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
       
    }
    else{
       const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
